import { BaseSpecialRenderer, SpecialFieldJsonData } from './base-special-renderer';
import { GdprRuntimeConfig, RenderOptions } from '../../models/element-types';

export interface GdprJsonData extends SpecialFieldJsonData {
    type: 'gdpr';
    consentText?: string;
    privacyPolicyUrl?: string;
}

export class GdprRenderer extends BaseSpecialRenderer<GdprJsonData> {
    protected override get defaultData(): GdprJsonData {
        return {
            id: '',
            type: 'gdpr'
        };
    }

    protected override renderElement(data: GdprJsonData, options?: RenderOptions): HTMLElement {
        const gdprConfig = (options?.runtimeContext as any)?.gdpr as GdprRuntimeConfig;

        if (!gdprConfig || !gdprConfig.enabled) {
            return document.createElement('div');
        }

        const wrapper = document.createElement('div');
        wrapper.classList.add('field-wrapper', 'field-gdpr');

        const label = document.createElement('label');
        label.classList.add('gdpr-label');

        const input = document.createElement('input');
        input.type = 'checkbox';
        input.id = `field-${data.id}`;
        input.name = data.id || '__gdprConsent';
        input.classList.add('field-input', 'gdpr-checkbox');
        input.value = 'true';
        input.required = true;

        input.setAttribute('aria-required', 'true');
        input.setAttribute('aria-invalid', 'false');

        const consentTextSpan = document.createElement('span');
        consentTextSpan.classList.add('gdpr-consent-text');

        if (gdprConfig.privacyPolicyUrl) {
            const textParts = gdprConfig.consentText.split(/(\[privacy policy\]|\[Privacy Policy\])/i);

            textParts.forEach(part => {
                if (/\[privacy policy\]/i.test(part)) {
                    const link = document.createElement('a');
                    link.href = gdprConfig.privacyPolicyUrl!;
                    link.textContent = 'Privacy Policy';
                    link.target = '_blank';
                    link.rel = 'noopener noreferrer';
                    consentTextSpan.appendChild(link);
                } else {
                    consentTextSpan.appendChild(document.createTextNode(part));
                }
            });
        } else {
            consentTextSpan.textContent = gdprConfig.consentText;
        }

        label.appendChild(input);
        label.appendChild(consentTextSpan);
        wrapper.appendChild(label);

        const errorContainer = this.createErrorContainer();
        wrapper.appendChild(errorContainer);

        return wrapper;
    }
}
